import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">六大分类，满足您全方位的浏览需求</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-primary-100 rounded-2xl group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-600`}></i>
              </div>
              <div className="text-center">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-400">{cat.count.toLocaleString()} 条内容</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}